export default class ContractRenewalService {

    constructor(private Restangular: any) {
        'ngInject';
    }

    public async getContractSigningUrl(offerId?: number, shownOfferIds?: number[]) {
        if (typeof offerId !== "undefined") {
            const params: any = { 'offerId': offerId };
            if (shownOfferIds && shownOfferIds.length) {
                params.shownOfferIds = shownOfferIds;
            }
            return this.Restangular
                .all('contract-renewal')
                .one('contract-signing-url')
                .withHttpConfig({
                    cache: false
                })
                .customGET('', params);
        }
        return this.Restangular
            .all('contract-renewal')
            .one('contract-signing-url')
            .withHttpConfig({
                cache: false
            })
            .get();
    }
}
